import React from "react";

const CCPAPolicy = ({ handleRedirect }) => {
  return (
    <div className=" w-full md:w-[817px] flex flex-col gap-6 pr-6 pl-6">
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal leading-[29.83px]">
        Effective date: 02/28/2024
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        This California Consumer Privacy Act Policy (the “CCPA Policy”) is
        incorporated by reference into the SourceIQ Privacy Policy, found
        <span
          style={{
            color: "black",
            fontWeight: "700",
            textDecoration: "underline",
            cursor: "pointer",
            marginLeft: "5px",
          }}
          onClick={() => handleRedirect("Privacy Policy")}
        >
          here
        </span>
        , and applies only to the Personal Information of California consumers,
        unless specified otherwise in the Privacy Policy. Any capitalized terms
        not defined in this CCPA Policy have the same meaning given to them in
        our Privacy Policy and/or the California Consumer Privacy Act (“CCPA”).
      </span>

      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        California Privacy
        <br></br>
        Information We Collect, Use, and Disclose
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        This section of the CCPA Policy provides information to California
        (“CA”) residents who have certain rights under the California Consumer
        Privacy Act of 2018 (“CCPA”) with respect to the personal information
        that we collect about you. California law requires us to disclose
        information about the categories of personal information we collect and
        how we use them, the categories of sources from which we collect
        personal information, and the third parties with whom we share personal
        information. We have provided detailed descriptions above in the
        “Information We Collect” “How We Use the Information We Collect and
        Receive” “Sharing Information” sections of the SourceIQ Privacy Policy.
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        We don’t sell nor share the personal information of California residents
        to any third parties as defined by applicable California law.
      </span>
      <span className="text-[#505050] text-[18px] sm:text-[22.95px] font-normal  leading-[29.83px]">
        Individual Rights
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        The CCPA provides California consumers with several individual rights
        with respect to Personal Information. Note that these rights apply to
        individual consumers, not to Companies.
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        We will not discriminate against you for exercising any of these rights.
      </span>
      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        Exercising Your Rights
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        To exercise any of the rights described in this section, please contact
        us at nina.legal@talkdei.io with (i) a complete description of your
        request, including the specific right(s) you wish to exercise and (ii)
        sufficient information about you so we can confirm that your request is
        a verifiable consumer request, including at a minimum your name and
        email address. Once we consistent with applicable law. Please note that
        you may also designate an authorized agent to make a request on your
        behalf. To do so, you must provide us with written authorization or a
        power of attorney, signed by you, for the agent to act on your behalf.
        You will still need to verify your identity directly with us.
      </span>

      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        Access and Data Portability Rights
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        You have the right to request that we disclose certain information to
        you about our collection and use of Personal Information: (1) categories
        of Personal Information we collected about you; categories of sources of
        Personal Information we have collected about you; our business or
        commercial purpose for collecting that Personal Information (if
        applicable); categories of Personal Information we have made available
        to our customers or partners, if any; and categories of Personal
        Information we disclosed to service providers or third parties, and the
        categories of those parties, for a business purpose, if any; and (2) the
        specific pieces of Personal Information we have collected about you in a
        readily useable format that allows you to transmit it to another entity
      </span>

      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        Deletion Rights
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        You have the right to request that we delete Personal Information about
        you that we have collected, subject to certain exceptions. We may retain
        a record of the request for the purpose of ensuring that the consumer’s
        personal information remains deleted from our database. The CCPA
        includes multiple exceptions to this deletion right. For example, we are
        not required to delete information if we need to use it for the
        following:
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        · Completing a transaction or contract with you.
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        · Detecting security interests, protecting against malicious, deceptive,
        fraudulent, or illegal activity, or prosecuting people responsible for
        that activity.
      </span>
      <span className="text-[#505050] text-xl font-normal  leading-[29.83px]">
        · Debugging our products to identify and repair errors to our Services
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        · Exercising, and allowing others to exercise, free speech, or other
        legal rights.
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        · Internal uses that align with your expectations.
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        · Complying with a legal requirement
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        · Other internal and lawful uses consistent with the reasons you
        provided the information.
      </span>
      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        Correction Rights
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        You have the right to request that we correct Personal Information we
        maintain about you, subject to certain exceptions.
      </span>
      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        Right to Opt-Out of Sharing or Sales of Personal Informatio
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        You have the right to direct us not to “share” or “sell” your Personal
        Information on a going-forward basis, as those terms are defined in the
        CCPA. We do not knowingly “sell” or “share” the personal information of
        children under 16, nor of any individual. Please email
        nina.legal@talkdei.io to exercise this right.
      </span>

      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        Non-Discrimination
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        You have the right not to receive discriminatory treatment for the
        exercise of your rights under the CCPA, subject to certain limitations.
        If applicable, any CCPA-permitted financial incentive we offer will
        reasonably relate to your personal information’s value and contain
        written terms that describe the program’s material aspects.
        Participation in a financial incentive program requires your prior
        opt-in consent, which you may revoke at any time by contacting us.
      </span>
      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        Sensitive Personal Information
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        The CCPA also allows you to limit the use or disclosure of your
        “sensitive personal information” (as defined in the CCPA) if your
        sensitive personal information is used for certain purposes. Please note
        that we do not use or disclose sensitive personal information.
      </span>

      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        Shine the Light Law
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        Under California Civil Code sections 1798.83-1798.84, also known as the
        “Shine the Light Law,” any of our users who are California residents may
        request and receive once a year, free of charge, a notice from us
        describing what categories of personal customer information we share
        with third parties for their direct marketing purposes. That notice will
        identify the categories of information shared, the third parties and
        affiliates with which it was shared, and their names and addresses. If
        you are a California resident and would like a copy of the notice that
        the law requires, please submit a written request to the following
        address: nina.legal@talkdei.io. In your request, please specify that you
        want a “California Privacy Rights Notice.” Please allow at least thirty
        days for a response.
      </span>
      <span className="text-[#505050] text-[18px] sm:text-[22.95px]  font-normal  leading-[29.83px]">
        Changes to this CCPA Policy
      </span>
      <span className="text-[#505050] text-sm sm:text-base md:text-xl font-normal  leading-[29.83px]">
        We reserve the right to amend this CCPA Policy at our discretion and at
        any time. When we make changes to this CCPA Policy, we will post the
        updated notice on the Site and update the CCPA Policy effective date at
        the top of the page. By accessing or using the Site and/or the Services,
        you acknowledge that you have read this CCPA Policy and, to the extent
        it applies to you, that you agree to the practices described in this
        CCPA Policy.
      </span>
    </div>
  );
};

export default CCPAPolicy;
